import { IScenarioObject } from '../../interfaces/iscenario-object';

export class ScenarioObjectBase {
  ScenarioObjectId: number;
  ScenarioId: number | null;
  Mappings: string | null;
  RigAndFracFleets: string | null;
  Relationships: string | null;
  ObligationsAndConstraints: string | null;
  ScheduleSettings: string | null;
  Prioritizations: string | null;
  WellSets: string | null;
  PreliminaryFilterCriterias: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  PreprocessingErrors: string | null;

  constructor(item?: IScenarioObject) {
    if (item) {

      this.ScenarioObjectId = item.ScenarioObjectId;
      this.ScenarioId = item.ScenarioId;
      this.Mappings = item.Mappings;
      this.RigAndFracFleets = item.RigAndFracFleets;
      this.Relationships = item.Relationships;
      this.ObligationsAndConstraints = item.ObligationsAndConstraints;
      this.ScheduleSettings = item.ScheduleSettings;
      this.Prioritizations = item.Prioritizations;
      this.WellSets = item.WellSets;
      this.PreliminaryFilterCriterias = item.PreliminaryFilterCriterias;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.PreprocessingErrors = item.PreprocessingErrors;

    }
  }
}